<template>
  <nav class="mira-nav" :class="{
    'mira-nav--solid': !isTransparent,
    'mira-nav--transparent': isTransparent,
    'mira-nav--homekind': isHomekind,
  }">
    <div class="mira-nav__inner">
      <router-link to="/" class="mira-nav__brand" :class="{ 'mira-nav__brand--hidden': isLanding }"
        :aria-hidden="String(isLanding)" :tabindex="isLanding ? -1 : 0">
        <HomekindLogo v-if="isHomekind" :size="40" />
        <template v-else>
          <img :src="logo" alt="Miraverse.ID" class="mira-nav__logo" />
          <span class="mira-nav__brand-text">Miraverse<span class="mira-nav__brand-accent">.ID</span></span>
        </template>
      </router-link>

      <div class="mira-nav__links" :class="{ 'mira-nav__links--open': isMenuOpen }">
        <router-link to="/" exact class="mira-nav__link" @click.native="closeMenu">Home</router-link>

        <div v-for="menu in menus" :key="menu.key" class="mira-nav__dropdown"
          :class="{ 'mira-nav__dropdown--open': openMenu === menu.key }" @mouseenter="onDropdownHover(menu.key, true)"
          @mouseleave="onDropdownHover(menu.key, false)">
          <button type="button" class="mira-nav__link mira-nav__dropdown-toggle"
            :class="{ 'mira-nav__link--active': isMenuRoute(menu) }" :aria-expanded="String(openMenu === menu.key)"
            @click="onDropdownClick(menu.key)">
            {{ menu.label }} <i class="fa fa-angle-down"></i>
          </button>
          <div class="mira-nav__dropdown-menu">
            <router-link v-for="item in menu.links" :key="item.to" :to="item.to" exact class="mira-nav__dropdown-item"
              @click.native="onItemClick(item.to)">
              <i :class="item.icon"></i>
              <span>{{ item.label }}</span>
            </router-link>
          </div>
        </div>

        <router-link to="/contact" class="mira-nav__link mira-nav__link--cta" @click.native="closeMenu">
          Hubungi Kami
        </router-link>
      </div>

      <button class="mira-nav__hamburger" :class="{ 'mira-nav__hamburger--active': isMenuOpen }" @click="toggleMenu"
        aria-label="Toggle navigation">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- Mobile Overlay -->
    <div class="mira-nav__overlay" :class="{ 'mira-nav__overlay--visible': isMenuOpen }" @click="closeMenu"></div>
  </nav>
</template>

<script>
import HomekindLogo from "@/components/homekind/HomekindLogo";

export default {
  name: "HeaderComponent",
  components: { HomekindLogo },
  data() {
    return {
      isTransparent: true,
      isMenuOpen: false,
      openMenu: null,
      menus: [
        {
          key: "homekind",
          label: "Homekind",
          links: [
            { to: "/homekind", label: "Ringkasan", icon: "fa fa-home" },
            { to: "/homekind#fitur", label: "Fitur", icon: "fa fa-th-large" },
            { to: "/homekind#tampilan", label: "Tampilan Aplikasi", icon: "fa fa-mobile" },
            { to: "/homekind#harga", label: "Harga", icon: "fa fa-tag" },
            { to: "/homekind#faq", label: "FAQ", icon: "fa fa-question-circle" },
          ],
        },
        {
          key: "solusi-it",
          label: "Solusi IT",
          links: [
            { to: "/solusi-it", label: "Ringkasan", icon: "fa fa-th-large" },
            { to: "/about", label: "Tentang Kami", icon: "fa fa-users" },
            { to: "/services", label: "Layanan", icon: "fa fa-cogs" },
            { to: "/projects", label: "Proyek", icon: "fa fa-briefcase" },
          ],
        },
      ],
      logo: require("@/assets/images/logo-mira.png"),
    };
  },
  computed: {
    // Only the Homekind product page uses Homekind branding; every other page is Miraverse
    isHomekind() {
      return this.$route.path === "/homekind";
    },
    // The split landing page shows both brands itself, so the navbar brand is hidden there
    isLanding() {
      return this.$route.path === "/";
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    $route() {
      this.closeMenu();
    },
  },
  methods: {
    handleScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      this.isTransparent = scrollTop <= 50 && !this.isMenuOpen;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (this.isMenuOpen) {
        this.isTransparent = false;
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
        this.handleScroll();
      }
    },
    // Hover only drives the dropdown on desktop pointers; touch devices rely on click
    canHover() {
      return window.matchMedia("(hover: hover) and (min-width: 992px)").matches;
    },
    isMenuRoute(menu) {
      return menu.links.some((item) => item.to.split("#")[0] === this.$route.path);
    },
    onDropdownHover(key, open) {
      if (!this.canHover()) return;
      if (open) this.openMenu = key;
      else if (this.openMenu === key) this.openMenu = null;
    },
    onDropdownClick(key) {
      if (this.canHover()) this.openMenu = key;
      else this.openMenu = this.openMenu === key ? null : key;
    },
    // Router ignores a click on the URL it is already on, so scroll manually in that case
    onItemClick(to) {
      const [path, hash] = to.split("#");
      if (this.$route.path === path) {
        const target = hash && this.$route.hash === "#" + hash ? document.getElementById(hash) : null;
        if (target) {
          window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - 80, behavior: "smooth" });
        } else if (!hash && !this.$route.hash) {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }
      this.closeMenu();
    },
    closeMenu() {
      this.isMenuOpen = false;
      this.openMenu = null;
      document.body.style.overflow = "";
      this.handleScroll();
    },
  },
};
</script>

<style scoped lang="scss">
.mira-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.35s ease;
  padding: 0 24px;
}

.mira-nav--transparent {
  background: transparent;
}

.mira-nav--solid {
  background: rgba(26, 10, 46, 0.97);
  backdrop-filter: blur(12px);
  box-shadow: 0 2px 20px rgba(26, 10, 46, 0.3);
}

.mira-nav__inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
}

.mira-nav__brand {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  z-index: 1001;
}

// Hidden but kept in the layout so the links stay right-aligned
.mira-nav__brand--hidden {
  visibility: hidden;
  pointer-events: none;
}

.mira-nav__logo {
  height: 42px;
  width: auto;
}

.mira-nav__brand-text {
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 1.2rem;
  font-weight: 700;
  color: #fff;
}

.mira-nav__brand-accent {
  color: #c73468;
}

.mira-nav__links {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mira-nav__link {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.92rem;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.25s ease;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.08);
  }

  &.router-link-exact-active {
    color: #c73468;
  }
}

.mira-nav__link--active {
  color: #c73468;
}

// Dropdown (Solusi IT)
.mira-nav__dropdown {
  position: relative;
}

.mira-nav__dropdown-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;

  i {
    transition: transform 0.25s ease;
  }
}

.mira-nav__dropdown--open .mira-nav__dropdown-toggle i {
  transform: rotate(180deg);
}

.mira-nav__dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 210px;
  padding: 8px;
  margin-top: 8px;
  background: rgba(26, 10, 46, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
  opacity: 0;
  visibility: hidden;
  transform: translateY(6px);
  transition: all 0.2s ease;

  // Bridges the gap so the menu stays open while the pointer moves down
  &::before {
    content: "";
    position: absolute;
    top: -10px;
    left: 0;
    right: 0;
    height: 10px;
  }
}

.mira-nav__dropdown--open .mira-nav__dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.mira-nav__dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  text-decoration: none;
  transition: all 0.2s ease;

  i {
    width: 16px;
    text-align: center;
    color: #c73468;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.06);
    color: #fff;
  }

  &.router-link-exact-active {
    color: #c73468;
  }
}

.mira-nav__link--cta {
  background: linear-gradient(135deg, #6c2973, #c73468);
  color: #fff !important;
  padding: 10px 24px;
  border-radius: 50px;
  font-weight: 600;
  margin-left: 8px;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 20px rgba(199, 52, 104, 0.4);
    background: linear-gradient(135deg, #6c2973, #c73468);
  }
}

// Hamburger
.mira-nav__hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 40px;
  height: 40px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  z-index: 1001;
  border-radius: 8px;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  span {
    width: 24px;
    height: 2px;
    background: #fff;
    border-radius: 2px;
    transition: all 0.3s ease;
  }

  &--active {
    span:nth-child(1) {
      transform: rotate(45deg) translate(5px, 5px);
    }

    span:nth-child(2) {
      opacity: 0;
    }

    span:nth-child(3) {
      transform: rotate(-45deg) translate(5px, -5px);
    }
  }
}

// Overlay
.mira-nav__overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: 0;
  transition: opacity 0.3s ease;

  &--visible {
    opacity: 1;
  }
}

@media (max-width: 991px) {
  .mira-nav__hamburger {
    display: flex;
  }

  .mira-nav__overlay {
    display: block;
    pointer-events: none;

    &--visible {
      pointer-events: auto;
    }
  }

  .mira-nav__links {
    position: fixed;
    top: 0;
    right: -320px;
    width: 300px;
    height: 100vh;
    background: #1a0a2e;
    flex-direction: column;
    align-items: flex-start;
    padding: 100px 32px 32px;
    gap: 4px;
    transition: right 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1000;
    box-shadow: -8px 0 30px rgba(0, 0, 0, 0.3);

    &--open {
      right: 0;
    }
  }

  .mira-nav__link {
    width: 100%;
    padding: 14px 16px;
    font-size: 1rem;
    border-radius: 10px;
  }

  .mira-nav__dropdown {
    width: 100%;
  }

  .mira-nav__dropdown-toggle {
    justify-content: space-between;
    text-align: left;
  }

  .mira-nav__dropdown-menu {
    position: static;
    display: none;
    min-width: 0;
    margin: 4px 0 0 12px;
    padding: 4px;
    background: rgba(255, 255, 255, 0.03);
    box-shadow: none;
    opacity: 1;
    visibility: visible;
    transform: none;

    &::before {
      display: none;
    }
  }

  .mira-nav__dropdown--open .mira-nav__dropdown-menu {
    display: block;
  }

  .mira-nav__link--cta {
    margin-left: 0;
    margin-top: 16px;
    text-align: center;
    justify-content: center;
    display: flex;
  }
}
// ===== Homekind theme (home page) =====
.mira-nav--homekind {
  &.mira-nav--solid {
    background: rgba(35, 51, 42, 0.97);
    box-shadow: 0 2px 20px rgba(28, 42, 34, 0.35);
  }

  .mira-nav__link {
    color: rgba(246, 241, 231, 0.85);

    &:hover {
      color: $hk-linen;
      background: rgba(246, 241, 231, 0.08);
    }

    &.router-link-exact-active,
    &.mira-nav__link--active {
      color: $hk-apricot-light;
    }
  }

  .mira-nav__link--cta {
    background: $hk-apricot;
    color: $hk-forest-deep !important;

    &:hover {
      background: $hk-apricot-light;
      box-shadow: 0 4px 20px rgba(224, 145, 95, 0.4);
    }
  }

  .mira-nav__dropdown-menu {
    background: rgba(35, 51, 42, 0.98);
    border-color: rgba(246, 241, 231, 0.1);
  }

  .mira-nav__dropdown-item {
    i,
    &.router-link-exact-active {
      color: $hk-apricot-light;
    }
  }
}

@media (max-width: 991px) {
  .mira-nav--homekind .mira-nav__links {
    background: $hk-forest-deep;
  }
}
</style>
